import { axiosInstance } from "../../../api/axiosInstance";
import { APIS, STUDENT_APIS } from "../../../modules/common/api/apis";
import { Student, StudentTotalSummary } from "../types";

export const get = async (admissionNo: string): Promise<Student> => {
  const params = new URLSearchParams();
  params.set("admissionNo", admissionNo);
  params.set("view", "detail");
  const response = await axiosInstance.get<Student>(`${APIS.STUDENTS}?${params.toString()}`);
  return response.data;
};

export const list = async (grade: string, section: string, status: string)
  : Promise<Student[]> => {
  const params = new URLSearchParams();
  params.set("grade", grade);
  params.set("section", section);
  params.set("status", status);
  params.set("view", "list");
  const response = await axiosInstance.get<Student[]>(`${APIS.STUDENTS}?${params.toString()}`);
  return response.data;
};

export const getTotalSummary = async (): Promise<StudentTotalSummary> => {
  const response = await axiosInstance.get<StudentTotalSummary>(STUDENT_APIS.TOTAL_SUMMARY);
  return response.data;
};